import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { withTranslation } from "react-i18next";
import { fetchCategories } from "../../_actions/storiesActions";
import TldrTagsInput from "./TldrTagsInput";
import EditableLabel from "./EditableLabel";
import { isEmpty } from "lodash";
import {
  Box,
  Button,
  ButtonGroup,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { defaultOptionsStyle } from "../styled/details/stylesSelect";
import TldrChakraSelect from "./TldrChakraSelect";

class TldrPublishTemplateModal extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);

    this.state = {
      selectedCategory: {},
      templateName: props.templateName,
      tags: [],
      formErrors: { name: "", tags: "", category: "" },
      nameValid: false,
      tagsValid: false,
      categoryValid: false,
      formValid: false,
    };
  }

  componentDidMount() {
    this.props.fetchCategories(this.props, this.signal.token);
    this.validateFields("name", this.state.templateName);
  }

  render() {
    const { show, onHide, onYes, inProgress, templateName, t } = this.props;
    const { formValid } = this.state;

    let categoryOptions = [];
    this.props.navbar.payload &&
      this.props.navbar.payload.results &&
      this.props.navbar.payload.results.forEach((cat) => {
        var data = {
          ...cat,
          value: cat.title.toLowerCase(),
          label: cat.title,
        };
        categoryOptions.push(data);
      });

    return (
      <Modal isOpen={show} onClose={onHide} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader p="4">
            {t("publish_template_modal.modal_title")}
          </ModalHeader>
          <ModalCloseButton />
          <Divider my="0" />

          <ModalBody p="3">
            <Flex direction="column">
              <Box mb="3">
                <Text mb="1">
                  {t("publish_template_modal.modal_body.template_name")}
                </Text>
                <EditableLabel
                  text={templateName}
                  labelClassName="templatetitlename"
                  inputClassName="templatetitleinput"
                  onFocus={(text) => this.handleFocus(text)}
                  onFocusOut={(text) => this.handleFocusOut(text)}
                  showIcon={true}
                  inputMaxLength={50}
                  labelPlaceHolder={t("publish_template_modal.label")}
                />
                <Text mt="1" mb="1" color="brand.negative">
                  {this.state.formErrors.name}
                </Text>
              </Box>

              <Box mb="3">
                <Text mb="1">
                  {t("publish_template_modal.modal_body.tags")}
                </Text>
                <TldrTagsInput
                  as="input"
                  applyTags={(tags) => this.applyTags(tags)}
                />
                <Text className="error" mt={1} mb={1}>
                  {this.state.formErrors.tags}
                </Text>
              </Box>

              <Box>
                <Text mb="1">
                  {t("publish_template_modal.modal_body.category")}
                </Text>
                <TldrChakraSelect
                  options={categoryOptions}
                  onChange={(selected) => this.selectCategory(selected)}
                  chakraStyles={defaultOptionsStyle}
                  isMulti
                  isInvalid={this.state.formErrors.category}
                />
              </Box>
              <Text mt="1" mb="1" color="brand.negative">
                {this.state.formErrors.category}
              </Text>
            </Flex>
          </ModalBody>
          <Divider my="0" />

          <ModalFooter p="3">
            <ButtonGroup>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onHide();
                }}
                colorScheme="primary"
                variant="secondary"
                disabled={inProgress}
              >
                {t("publish_template_modal.modal_cancel_btn")}
              </Button>

              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onYes(
                    this.state.templateName,
                    this.state.tags,
                    this.state.selectedCategory
                  );
                }}
                colorScheme="primary"
                variant="solid"
                disabled={!formValid}
                isLoading={inProgress}
                loadingText={t("publish_template_modal.modal_publishing_btn")}
              >
                {t("publish_template_modal.modal_publish_btn")}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }

  selectCategory = (selected) => {
    this.setState(
      {
        ...this.state,
        selectedCategory: selected,
      },
      () => this.validateFields("category", selected)
    );
  };

  applyTags = (tags) => {
    this.setState(
      {
        ...this.state,
        tags: tags,
      },
      () => this.validateFields("tags", tags)
    );
  };

  handleFocus = (text) => {};

  handleFocusOut = (text) => {
    this.setState(
      {
        ...this.state,
        templateName: text,
      },
      () => this.validateFields("name", text)
    );
  };

  validateFields = (fieldName, value) => {
    let fieldValidationErrors = this.state.formErrors;
    let nameValid = this.state.nameValid;
    let tagsValid = this.state.tagsValid;
    let categoryValid = this.state.categoryValid;
    const { t } = this.props;

    switch (fieldName) {
      case "name":
        nameValid = value.length > 0;
        fieldValidationErrors.name = nameValid
          ? ""
          : t("publish_template_modal.give_name_msg", { ns: "studio" });
        break;
      case "tags":
        tagsValid = value.length > 0;
        fieldValidationErrors.tags = tagsValid
          ? ""
          : t("publish_template_modal.give_tag", { ns: "studio" });
        break;
      case "category":
        categoryValid = !isEmpty(value);
        fieldValidationErrors.category = categoryValid
          ? ""
          : t("publish_template_modal.select_category", { ns: "studio" });
        break;
      default:
        break;
    }

    this.setState(
      {
        formErrors: fieldValidationErrors,
        nameValid: nameValid,
        tagsValid: tagsValid,
        categoryValid: categoryValid,
      },
      this.validateForm
    );
  };

  validateForm = () => {
    this.setState({
      formValid:
        this.state.nameValid &&
        this.state.tagsValid &&
        this.state.categoryValid,
    });
  };
}

TldrPublishTemplateModal.propTypes = {
  fetchCategories: PropTypes.func.isRequired,
  t: PropTypes.func,
};

const mapStateToProps = (state) => ({
  navbar: state.navbar,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCategories: (props, signalToken) =>
    dispatch(fetchCategories(props, signalToken)),
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(TldrPublishTemplateModal)
);
